var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editorPageTable"},[_c('div',{staticClass:"editorPageTable__wrapper"},[_c('SimpleTable',{attrs:{"data":_vm.tableContents,"variants":['smallHeadings', 'borderInside', 'smallPaddings', 'sameFonts'],"blog":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }